import { useStateQueryParams } from 'app/common/hooks/useStateQueryParams';

import { BusinessModalQueryParams } from '../../helpers/queryParams';

export const useBusinessCityQueryParams = () => {
    const [businessCity, setBusinessCity] = useStateQueryParams(BusinessModalQueryParams.City);
    return {
        businessCity,
        setBusinessCity,
    };
};
